import Base from './base'

type StakeholderResponse = {
  data?: unknown
}

export type Stakeholder = {
  id: number
  personId: number
}

const isStakeholder = (value: unknown): value is { id: number; person_id: number } => {
  if (typeof value !== 'object' || value === null) return false

  const stakeholder = value as Record<string, unknown>

  return typeof stakeholder.id === 'number' && typeof stakeholder.person_id === 'number'
}

export default class Stakeholders extends Base {
  async allForOpportunityCrmId(opportunityCrmId: string): Promise<Stakeholder[]> {
    const response: StakeholderResponse = await this.api.get('stakeholders', {
      params: { opportunity_crm_id: opportunityCrmId },
    })

    if (!Array.isArray(response?.data)) return []

    return response.data
      .filter(isStakeholder)
      .map(stakeholder => ({ id: stakeholder.id, personId: stakeholder.person_id }))
  }
}
